import { LOADING_STATE } from '../../brands/default/constants';

export const setLoadingState = (status, message) => (dispatch) => {
  return dispatch({ message, status, type: LOADING_STATE.SET_LOADING_STATUS });
};
